import styled from 'styled-components'
import { height, HeightProps, width, WidthProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { motion } from 'framer-motion'

export const Container = styled.div<WidthProps & HeightProps>`
  position: relative;
  display: flex;
  width: 100%;

  ${width}
  ${height}
`

export const BackgroundImageHolder = styled.div<WidthProps & HeightProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
  flex-shrink: 0;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  ${width}
  ${height}
`

export const IconImageContainer = styled.div<WidthProps & HeightProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 700px;
  height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);

  ${width}
  ${height}
`

export const IconImageHolder = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: translateX(4px);

    @media screen and (min-width: ${themeGet('breakpoints.2')}) {
      transform: translateX(6px);
    }

    @media screen and (min-width: ${themeGet('breakpoints.4')}) {
      transform: translateX(8px);
    }
  }
`
